import { Image, Row, Tooltip, Icon, Text, TextVariant } from "@bridgesplit/ui";
import { usePresetMarketInfos } from "@bridgesplit/abf-react";
import { OracleType } from "@bridgesplit/abf-sdk";
import { getOracleTypes, useOracleStats } from "app/components/oracles/useOracleStats";
import { Box } from "@mui/material";

import { getOracleMeta } from "../common/pricing";
import OracleTooltipTitle from "./OracleTooltipTitle";

export default function OracleLogos({
    principalMint,
    collateralMint,
    variant
}: {
    principalMint: string | undefined;
    collateralMint: string | undefined;
    variant: TextVariant;
}) {
    const { getMarketByCollateralAndPrincipalMint, getPrincipalMarketInfo } = usePresetMarketInfos({
        filter: {
            principalMints: principalMint ? [principalMint] : undefined,
            collateralMints: collateralMint ? [collateralMint] : undefined
        },
        skip: !principalMint || !collateralMint
    });

    const collateralAssetMarketInfo = getMarketByCollateralAndPrincipalMint(collateralMint, principalMint);

    const principalAssetMarketInfo = getPrincipalMarketInfo(principalMint);

    const allOracleTypes = getOracleTypes({
        collateralMarketData: collateralAssetMarketInfo?.ltvInfo,
        principalMarketData: principalAssetMarketInfo?.ltvInfo
    });

    const oracleStats = useOracleStats({
        collateralMarketData: collateralAssetMarketInfo?.ltvInfo,
        principalMarketData: principalAssetMarketInfo?.ltvInfo,
        variant: variant
    });

    return (
        <Tooltip
            minTooltipWidth="175px"
            title={
                <OracleTooltipTitle
                    topLevelOracleStats={oracleStats?.topLevelOracleStats}
                    customOracleStats={oracleStats?.customOracleStats}
                    variant={variant}
                />
            }
            reverseColors
        >
            <Row spacing={1}>
                <Text variant={variant} svgColor="caption">
                    <Icon type="help" />
                </Text>
                <LayeredOracleLogos allOracles={allOracleTypes} />
            </Row>
        </Tooltip>
    );
}

function LayeredOracleLogos({ allOracles }: { allOracles: OracleType[] }) {
    return (
        <Box sx={{ position: "relative", display: "flex" }}>
            {allOracles.map((meta, index) => {
                const oracleMeta = getOracleMeta(meta);
                return (
                    <Image
                        key={index}
                        variant="circle"
                        size="16px"
                        src={oracleMeta?.image}
                        sx={{
                            marginLeft: index > 0 ? "-4px" : 0,
                            zIndex: allOracles.length - index,
                            position: "relative"
                        }}
                    />
                );
            })}
        </Box>
    );
}
